<template>
  <div class="cabinet-wrapper projects" v-if="!video || !idCorresponds || initialGeneration">
    <div class="topic-generating-container video-generating-container topic-list-container">
      <div class="topic-generating-header">
        <div class="title small">
          <b>{{ $t('Generated video') }}</b>
        </div>
        <div class="top">
          <div class="desc">
            <b>{{ $t('New video') }}</b>
          </div>
          <a @click.prevent="modalsStore.openVideoPathsModal()" class="open-button">
            <img
                class="img"
                src="./../assets/img/topUp.svg"
            />
          </a>
        </div>
      </div>
      <div class="bottom">
        <!--        <div class="desc empty-desc" v-if="!modalStepsDone">-->
        <!--          {{ $t('Your titles appear here once you create a topic') }}-->
        <!--        </div>-->
        <div v-if="!route.params.id" class="bottom-form">
          <label class="search-label">
            <input
                name="search"
                type="text"
                :placeholder="$t('Search')"
                required
                v-model="projectsSearchQuery"
            />
            <img
                class="search-img"
                src="./../assets/img/icons/search.svg"
            />
          </label>
          <div class="titles-with-actions-list">
            <div
                v-for="project in projectsFound"
                :key="project.id"
                :class="['title-actions']"
                @click="router.push({name: 'CabinetPage', params: {page: 'video', id: project.id}})"
            >
              <div class="desc">
                <b>{{ $t(project.title) }}</b>
              </div>
              <div class="actions">
                <!--                <a class="actions__item">-->
                <!--                  <img-->
                <!--                      class="img"-->
                <!--                      src="./../assets/img/icons/generate.svg"-->
                <!--                  />-->
                <!--                </a>-->
                <!--                <a class="actions__item">-->
                <!--                  <img-->
                <!--                      class="img"-->
                <!--                      src="./../assets/img/icons/publish.svg"-->
                <!--                  />-->
                <!--                </a>-->
                <!--                <a class="actions__item">-->
                <!--                  <img-->
                <!--                      class="img"-->
                <!--                      src="./../assets/img/icons/translate.svg"-->
                <!--                  />-->
                <!--                </a>-->
                <a @click.prevent.stop="deleteProject(project.id)" class="actions__item">
                  <img
                      class="img"
                      src="./../assets/img/icons/bin.svg"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="cabinet-wrapper" v-else>
    <div class="video-generating-container">
      <div class="video-generating-left">
        <div class="video-generating-left-header">
          <a
              @click.prevent="router.push({name: 'CabinetPage', params: {page: 'video'}})"
              class="back"
          >
            <img
                src="./../assets/img/icons/back.svg"
                class="img"
            >
            <div class="desc">
              {{ $t('Back') }}
            </div>
          </a>
          <div class="title small">
            <b>{{ video?.title }}</b>
          </div>
          <a
              class="edit"
          >
            <img
                src="./../assets/img/icons/edit.svg"
                class="img"
            >
          </a>
        </div>
        <div class="video-generating-left-bar">
          <div class="left">
            <select @change="updateStyles('fontFamily', $event.target.value)" class="font-family-select">
              <option :key="font" v-for="font in fonts">{{ font }}</option>
            </select>
            <select :value="selectedScene?.fontSize || 18" @change="updateStyles('fontSize', $event.target.value)"
                    class="font-size-select">
              <option :key="size" :value="size" v-for="size in fontSizes">{{ size }}</option>
            </select>
            <a @click.prevent="toggleBold" class="text-button">
              <img
                  class="img"
                  src="./../assets/img/icons/bold.svg"
              />
            </a>
            <a @click.prevent="toggleItalic" class="text-button">
              <img
                  class="img"
                  src="./../assets/img/icons/italic.svg"
              />
            </a>
            <a @click.prevent="toggleUnderline" class="text-button">
              <img
                  class="img"
                  src="./../assets/img/icons/underline.svg"
              />
            </a>
            <a class="text-button color-button">
              <img
                  class="img"
                  src="./../assets/img/icons/color.svg"
              />
              <color-picker v-model:pureColor="pureColor"/>
            </a>
          </div>
          <div class="right">
<!--            <div class="time-dropdown-container">-->
<!--              <a class="time-button" @click="settingsIsActive = !settingsIsActive">-->
<!--                <img-->
<!--                    class="img"-->
<!--                    src="./../assets/img/icons/time.svg"-->
<!--                />-->
<!--                <div class="desc small">{{ $t(`${Math.round(sceneDuration)}s`) }}</div>-->
<!--                <img-->
<!--                    src="./../assets/img/arrow-down-dark.svg"-->
<!--                    class="arrow"-->
<!--                >-->
<!--              </a>-->
<!--              <div :class="['settings-dropdown time-dropdown', {'active': settingsIsActive}]">-->
<!--                <div class="time-dropdown-wrapper">-->
<!--                  <div class="desc small">-->
<!--                    <b>{{ $t('Scene duration (seconds)') }}:</b>-->
<!--                  </div>-->
<!--                  <label>-->
<!--                    <input-->
<!--                        name="title"-->
<!--                        type="text"-->
<!--                        v-model="sceneDurationLocal"-->
<!--                    />-->
<!--                  </label>-->
<!--                  <div class="desc small">-->
<!--                    <b>{{ $t('Apply to:') }}</b>-->
<!--                  </div>-->
<!--                  <div class="buttons">-->
<!--                    <button :disabled="!scenesDuration" @click="updateDuration(true)" class="button small lined">-->
<!--                      <span>{{ $t('All scenes') }}</span>-->
<!--                    </button>-->
<!--                    <button :disabled="!scenesDuration" @click="updateDuration(false)" class="button small">-->
<!--                      <span>{{ $t('This scene') }}</span>-->
<!--                    </button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
            <div class="ratio-dropdown-container">
              <a class="ratio-button" @click="ratioDropdownIsActive = !ratioDropdownIsActive">

                <img
                    v-if="orientation == 'landscape'"
                    src="./../assets/img/icons/ratio1.svg"
                    class="ratio-img"
                >
                <img
                    v-if="orientation == 'portrait'"
                    src="./../assets/img/icons/ratio2.svg"
                    class="ratio-img"
                >
                <img
                    src="./../assets/img/arrow-down-dark.svg"
                    class="img"
                >
              </a>
              <div :class="['settings-dropdown ratio-dropdown', {'active': ratioDropdownIsActive}]">
                <div class="ratio-dropdown-wrapper">
                  <div class="desc small">
                    <b>{{ $t('Ratio') }}:</b>
                  </div>

                  <label>
                    <input type="radio" name="radio" value="landscape" v-model="orientation"/>
                    <div class="label-wrapper">
                      <svg width="46" height="26" viewBox="0 0 46 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.6925 17H10.9995V10.473L8.97852 11.1V9.72298L12.5115 8.45698H12.6935L12.6925 17ZM20.0575 8.38098V9.77598H19.8935C19.2262 9.7554 18.5726 9.96751 18.0445 10.376C17.5662 10.7839 17.2647 11.3614 17.2035 11.987C17.4265 11.7595 17.6941 11.5806 17.9896 11.4617C18.2852 11.3427 18.6021 11.2863 18.9205 11.296C19.2574 11.2829 19.5927 11.3484 19.8999 11.4872C20.2071 11.6261 20.4778 11.8345 20.6905 12.096C21.151 12.6962 21.3834 13.4404 21.3465 14.196C21.354 14.7202 21.2303 15.2379 20.9865 15.702C20.7547 16.1426 20.4005 16.5069 19.9665 16.751C19.5112 17.005 18.9969 17.1344 18.4755 17.126C18.0653 17.1396 17.6573 17.0618 17.2809 16.8982C16.9046 16.7345 16.5693 16.4892 16.2995 16.18C15.7207 15.4794 15.425 14.5876 15.4705 13.68V13.071C15.4543 12.2227 15.6354 11.3823 15.9995 10.616C16.3262 9.93136 16.8481 9.35867 17.4995 8.96998C18.191 8.57146 18.9775 8.3679 19.7755 8.38098H20.0575ZM18.4055 12.658C18.1421 12.655 17.8835 12.7291 17.6615 12.871C17.4452 13.006 17.274 13.2024 17.1695 13.435V13.95C17.1416 14.415 17.2567 14.8774 17.4995 15.275C17.6021 15.4279 17.7422 15.5521 17.9064 15.6356C18.0706 15.7191 18.2535 15.7591 18.4375 15.752C18.6082 15.7561 18.7774 15.7192 18.9309 15.6444C19.0844 15.5696 19.2176 15.459 19.3195 15.322C19.5554 14.9999 19.6743 14.6069 19.6565 14.208C19.6758 13.8057 19.5557 13.409 19.3165 13.085C19.2091 12.947 19.0706 12.8363 18.9123 12.7621C18.7539 12.6879 18.5803 12.6522 18.4055 12.658ZM23.4895 16.168C23.485 16.0455 23.507 15.9235 23.5539 15.8103C23.6009 15.6971 23.6717 15.5953 23.7615 15.512C23.9477 15.3422 24.1927 15.2518 24.4445 15.26C24.6979 15.2513 24.9447 15.3417 25.1325 15.512C25.2224 15.5953 25.2932 15.6971 25.3401 15.8103C25.3871 15.9235 25.409 16.0455 25.4045 16.168C25.4087 16.2889 25.3867 16.4093 25.3401 16.521C25.2936 16.6326 25.2234 16.7329 25.1345 16.815C24.9452 16.9845 24.6974 17.0738 24.4435 17.064C24.1912 17.0733 23.9451 16.984 23.7575 16.815C23.669 16.7327 23.5992 16.6324 23.553 16.5207C23.5067 16.4091 23.4851 16.2887 23.4895 16.168ZM23.4895 11.368C23.485 11.2455 23.507 11.1235 23.5539 11.0103C23.6009 10.8971 23.6717 10.7953 23.7615 10.712C23.9477 10.5422 24.1927 10.4518 24.4445 10.46C24.6979 10.4513 24.9447 10.5417 25.1325 10.712C25.2224 10.7953 25.2932 10.8971 25.3401 11.0103C25.3871 11.1235 25.409 11.2455 25.4045 11.368C25.4087 11.4889 25.3867 11.6093 25.3401 11.721C25.2936 11.8326 25.2234 11.9329 25.1345 12.015C24.9452 12.1845 24.6974 12.2738 24.4435 12.264C24.1912 12.2733 23.9451 12.184 23.7575 12.015C23.6691 11.9328 23.5994 11.8326 23.5532 11.7212C23.5069 11.6097 23.4852 11.4886 23.4895 11.368ZM31.6735 13.59C31.4728 13.7971 31.2323 13.9614 30.9664 14.0731C30.7006 14.1848 30.4149 14.2416 30.1265 14.24C29.7859 14.2538 29.4465 14.1913 29.1332 14.057C28.8198 13.9227 28.5405 13.7201 28.3155 13.464C27.8373 12.8739 27.5951 12.1274 27.6355 11.369C27.6292 10.8343 27.7542 10.3061 27.9995 9.83098C28.2302 9.3783 28.5846 9.00034 29.0215 8.74098C29.4689 8.47838 29.9798 8.34349 30.4985 8.35098C31.029 8.34194 31.5505 8.48866 31.9985 8.77298C32.4492 9.06952 32.8037 9.49106 33.0185 9.98598C33.2711 10.557 33.398 11.1756 33.3905 11.8V12.427C33.4594 13.6353 33.0818 14.8268 32.3295 15.775C31.9482 16.191 31.4833 16.5218 30.9653 16.7459C30.4473 16.9699 29.8878 17.082 29.3235 17.075L28.9075 17.081V15.67L29.2825 15.664C29.5777 15.6952 29.8762 15.6653 30.1593 15.5763C30.4425 15.4872 30.7043 15.3409 30.9286 15.1464C31.1528 14.9519 31.3347 14.7134 31.4628 14.4456C31.591 14.1779 31.6627 13.8866 31.6735 13.59ZM30.5425 12.945C30.7943 12.9515 31.0416 12.8776 31.2485 12.734C31.4372 12.603 31.591 12.4279 31.6965 12.224V11.524C31.7243 11.0558 31.6099 10.5901 31.3685 10.188C31.2752 10.0399 31.1453 9.91843 30.9913 9.83522C30.8373 9.75202 30.6645 9.70992 30.4895 9.71298C30.3218 9.71322 30.1569 9.75611 30.0103 9.83763C29.8637 9.91915 29.7402 10.0366 29.6515 10.179C29.4225 10.5247 29.3078 10.9336 29.3235 11.348C29.3053 11.7562 29.4174 12.1596 29.6435 12.5C29.7437 12.6439 29.8786 12.7602 30.0358 12.838C30.193 12.9158 30.3673 12.9526 30.5425 12.945Z"
                            fill="#6F6B79"/>
                        <path
                            d="M42 26H40V24H42C42.5304 24 43.0392 23.7893 43.4143 23.4142C43.7894 23.0391 44 22.5304 44 22V20H46V22C46 23.0609 45.5785 24.0782 44.8284 24.8284C44.0782 25.5785 43.0609 26 42 26ZM6 26H4C2.93913 26 1.92178 25.5785 1.17163 24.8284C0.421485 24.0782 0 23.0609 0 22V20H2V22C2 22.5304 2.21062 23.0391 2.58569 23.4142C2.96077 23.7893 3.46957 24 4 24H6V26ZM46 6H44V4C44 3.46957 43.7894 2.96089 43.4143 2.58582C43.0392 2.21074 42.5304 2 42 2H40V0H42C43.0609 0 44.0782 0.421485 44.8284 1.17163C45.5785 1.92178 46 2.93913 46 4V6ZM2 6H0V4C0 2.93913 0.421485 1.92178 1.17163 1.17163C1.92178 0.421485 2.93913 0 4 0H6V2H4C3.46957 2 2.96077 2.21074 2.58569 2.58582C2.21062 2.96089 2 3.46957 2 4V6Z"
                            fill="#6F6B79"/>
                      </svg>
                      <div class="desc small">
                        <b>{{ $t('Landscape 16:9') }}</b>
                      </div>
                    </div>
                  </label>

                  <label>
                    <input type="radio" name="radio" value="portrait" v-model="orientation"/>
                    <div class="label-wrapper">
                      <svg width="26" height="36" viewBox="0 0 26 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M0 32V30H2V32C2 32.5304 2.21074 33.0392 2.58582 33.4143C2.96089 33.7894 3.46957 34 4 34H6V36H4C2.93913 36 1.92178 35.5785 1.17163 34.8284C0.421486 34.0782 0 33.0609 0 32ZM0 6V4C0 2.93913 0.421486 1.92178 1.17163 1.17163C1.92178 0.421485 2.93913 0 4 0L6 0V2H4C3.46957 2 2.96089 2.21062 2.58582 2.58569C2.21074 2.96077 2 3.46957 2 4V6H0ZM20 36V34H22C22.5304 34 23.0391 33.7894 23.4142 33.4143C23.7893 33.0392 24 32.5304 24 32L24 30H26V32C26 33.0609 25.5785 34.0782 24.8284 34.8284C24.0782 35.5785 23.0609 36 22 36H20ZM20 2V0L22 0C23.0609 0 24.0782 0.421485 24.8284 1.17163C25.5785 1.92178 26 2.93913 26 4V6H24V4C24 3.46957 23.7893 2.96077 23.4142 2.58569C23.0391 2.21062 22.5304 2 22 2H20Z"
                            fill="#6F6B79"/>
                        <path
                            d="M5.95831 18.7744C5.77527 18.9632 5.55591 19.1132 5.31342 19.2151C5.07093 19.317 4.81033 19.3688 4.54731 19.3674C4.23724 19.3794 3.92839 19.3221 3.64328 19.1996C3.35818 19.0771 3.10401 18.8926 2.89931 18.6593C2.46359 18.1212 2.24271 17.4408 2.27931 16.7494C2.27458 16.2624 2.38926 15.7817 2.61331 15.3493C2.82369 14.9365 3.14687 14.5918 3.54531 14.3553C3.95311 14.1163 4.41863 13.9935 4.89131 14.0003C5.37437 13.9922 5.84924 14.1257 6.25731 14.3844C6.66738 14.6531 6.99049 15.0353 7.18731 15.4844C7.41646 16.0042 7.53138 16.5672 7.52431 17.1354V17.7074C7.58899 18.8115 7.24475 19.9009 6.55731 20.7674C6.20964 21.1468 5.78577 21.4486 5.31343 21.653C4.84109 21.8574 4.33093 21.9597 3.81631 21.9534L3.43731 21.9584V20.6714L3.77831 20.6663C4.04754 20.6948 4.31973 20.6675 4.57798 20.5863C4.83623 20.505 5.075 20.3715 5.27946 20.1941C5.48392 20.0166 5.6497 19.799 5.76648 19.5548C5.88326 19.3106 5.94856 19.0449 5.95831 18.7744ZM4.92731 18.1844C5.15693 18.1905 5.38252 18.1232 5.57131 17.9924C5.74351 17.873 5.88392 17.7134 5.98031 17.5274V16.8944C6.00527 16.4674 5.90071 16.0429 5.68031 15.6763C5.59527 15.5416 5.47703 15.4311 5.33693 15.3552C5.19683 15.2794 5.03959 15.2409 4.88031 15.2433C4.72734 15.2434 4.57691 15.2825 4.44324 15.3569C4.30956 15.4312 4.19704 15.5384 4.11631 15.6684C3.90714 15.9835 3.80221 16.3564 3.81631 16.7344C3.80073 17.1046 3.90258 17.4704 4.10731 17.7794C4.19881 17.9105 4.32195 18.0163 4.4653 18.0871C4.60866 18.1579 4.76758 18.1914 4.92731 18.1844ZM9.05731 21.1253C9.05293 21.0134 9.07283 20.9018 9.11564 20.7982C9.15844 20.6946 9.22315 20.6016 9.30531 20.5254C9.47483 20.3707 9.69795 20.2882 9.92731 20.2954C10.1586 20.2874 10.3839 20.3699 10.5553 20.5254C10.6375 20.6016 10.7022 20.6946 10.745 20.7982C10.7878 20.9018 10.8077 21.0134 10.8033 21.1253C10.8071 21.2356 10.7872 21.3454 10.7447 21.4472C10.7022 21.549 10.6383 21.6405 10.5573 21.7154C10.3847 21.8699 10.1588 21.9513 9.92731 21.9423C9.6965 21.9519 9.47112 21.8708 9.29931 21.7164C9.21888 21.641 9.15563 21.5492 9.11387 21.4472C9.07211 21.3452 9.05282 21.2355 9.05731 21.1253ZM9.05731 16.7494C9.05293 16.6374 9.07283 16.5258 9.11564 16.4222C9.15844 16.3186 9.22315 16.2256 9.30531 16.1494C9.47483 15.9947 9.69795 15.9122 9.92731 15.9194C10.1586 15.9114 10.3839 15.9939 10.5553 16.1494C10.6375 16.2256 10.7022 16.3186 10.745 16.4222C10.7878 16.5258 10.8077 16.6374 10.8033 16.7494C10.8071 16.8596 10.7872 16.9694 10.7447 17.0712C10.7022 17.173 10.6383 17.2645 10.5573 17.3394C10.3847 17.4939 10.1588 17.5753 9.92731 17.5664C9.6965 17.5759 9.47112 17.4948 9.29931 17.3404C9.21888 17.265 9.15563 17.1732 9.11387 17.0712C9.07211 16.9692 9.05282 16.8595 9.05731 16.7494ZM16.0503 21.8844H14.5063V15.9324L12.6633 16.5044V15.2484L15.8843 14.0944H16.0503V21.8844ZM22.7663 14.0244V15.2963H22.6163C22.0081 15.2769 21.4121 15.4696 20.9303 15.8413C20.4941 16.2133 20.2192 16.7399 20.1633 17.3104C20.3669 17.1034 20.6112 16.941 20.8807 16.8332C21.1502 16.7255 21.4392 16.6748 21.7293 16.6844C22.0363 16.6722 22.3419 16.7315 22.622 16.8577C22.9021 16.9838 23.149 17.1734 23.3433 17.4114C23.7634 17.9579 23.976 18.6358 23.9433 19.3244C23.9487 19.8007 23.8353 20.2709 23.6133 20.6923C23.4018 21.0939 23.0789 21.4259 22.6833 21.6484C22.268 21.8801 21.7988 21.9981 21.3233 21.9904C20.95 22.0037 20.5784 21.9341 20.2353 21.7864C19.8922 21.6387 19.5862 21.4167 19.3393 21.1364C18.8112 20.4972 18.5415 19.6834 18.5833 18.8554V18.2994C18.5676 17.5271 18.7312 16.7617 19.0613 16.0634C19.3607 15.4387 19.8385 14.9167 20.4343 14.5634C21.065 14.1999 21.7825 14.0143 22.5103 14.0263L22.7663 14.0244ZM21.2593 17.9244C21.0188 17.9218 20.7828 17.9896 20.5803 18.1193C20.3829 18.2427 20.2266 18.4219 20.1313 18.6344V19.1034C20.1056 19.5272 20.2103 19.9488 20.4313 20.3113C20.5249 20.4508 20.6525 20.564 20.8022 20.6401C20.9519 20.7162 21.1185 20.7528 21.2863 20.7464C21.4412 20.7494 21.5947 20.7155 21.7338 20.6473C21.873 20.5791 21.9938 20.4787 22.0863 20.3544C22.3034 20.0613 22.4138 19.7028 22.3993 19.3384C22.4165 18.9716 22.3071 18.61 22.0893 18.3144C21.9914 18.1886 21.8652 18.0879 21.721 18.0203C21.5767 17.9527 21.4185 17.9191 21.2593 17.9244Z"
                            fill="#6F6B79"/>
                      </svg>
                      <div class="desc small">
                        <b>{{ $t('Portrait 9:16') }}</b>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div :class="{'with-cut': cutIsVisible}" class="video-generating-left-main">
          <div class="preview">
            <figure :class="[orientation]">
              <img v-if="backgroundType === 'image'"
                   class="img"
                   :src="selectedScene?.backgroundUri"
              />
              <video
                  v-else-if="backgroundType === 'video'"
                  ref="player"
                  :src="selectedScene?.backgroundUri"
                  class="img"
                  width="130"
                  height="72"
                  @play="isPlaying = true"
                  @pause="videoPause"
                  @ended="videoEnded"
                  @timeupdate="checkVideoTime"
                  :loop="previewIsPlaying"
              ></video>

              <img
                  v-if="!isPlaying"
                  @click="togglePlay"
                  class="play-img"
                  src="./../assets/img/icons/play2.svg"
              />
              <img
                  v-else
                  @click="togglePlay"
                  class="play-img"
                  src="./../assets/img/icons/stop2.svg"
              />
              <div v-if="!cutIsVisible && selectedScene?.subtitles" class="desc small">
                <span :style="sceneStyles" v-html="selectedScene?.text" class="text">
                </span>
              </div>
            </figure>
          </div>
          <div class="cut-container" v-if="cutIsVisible">
            <a class="play-button">
              <img
                  @click="togglePlay"
                  v-if="!isPlaying"
                  src="./../assets/img/icons/play.svg"
                  class="img"
              >
              <img
                  @click="togglePlay"
                  v-else
                  src="./../assets/img/icons/stop.svg"
                  class="img"
              >
            </a>
            <MultiRangeSlider
                :min="0"
                :max="actualSceneDuration"
                :step="0.01"
                :ruler="false"
                :label="false"
                :rangeMargin="0"
                :minValue="barMinValue"
                :maxValue="barMaxValue"
                @input="updateRangeValues"
            />
            <div class="options">
              <a @click.prevent="handleSceneCut" class="ok-button">
                <img
                    src="./../assets/img/icons/ok.svg"
                    class="img"
                >
              </a>
              <a @click.prevent="cutIsVisible = !cutIsVisible; resetAll();" class="no-button">
                <img
                    src="./../assets/img/icons/no.svg"
                    class="img"
                >
              </a>
            </div>
            <div class="time desc small">{{ formatTimeCut(actualSceneDuration) }}</div>
          </div>
        </div>

        <div class="blur-overlay" v-if="cutIsVisible" @click.self="cutIsVisible = false; resetAll()"></div>

        <div class="video-generating-left-bar">
          <div class="left">
            <a
                class="undo"
            >
              <img
                  src="./../assets/img/icons/undo.svg"
                  class="img"
              >
            </a>
            <a
                class="redo"
            >
              <img
                  src="./../assets/img/icons/redo.svg"
                  class="img"
              >
            </a>
            <a @click.prevent="handleScenePreview" class="play-button play-button2">
              <img
                  v-if="!previewIsPlaying"
                  src="./../assets/img/icons/play.svg"
                  class="img"
              >
              <img
                  v-else
                  src="./../assets/img/icons/stop_play.svg"
                  class="img"
              >
              <div class="desc small">
                {{ $t('Preview scene') }}
              </div>
            </a>
          </div>
          <div class="right">
            <div v-click-outside="clickOutside" class="transition-dropdown-container">
              <a class="transition-button text-button"
                 @click="clickTransition">
                <img
                    class="img"
                    src="./../assets/img/icons/transition.svg"
                />
              </a>
              <div :class="['settings-dropdown transition-dropdown', {'active': transitionDropdownIsActive}]">
                <div class="transition-dropdown-wrapper">
                  <div class="desc small">
                    <b>{{ $t('Transition') }}:</b>
                  </div>
                  <div class="radio-list">
                    <label :key="value" v-for="[value, name] in Object.entries(transitions)">
                      <input type="radio" name="radio" :value="value" @click="updateTransition(value)">
                      <div class="label-wrapper">
                        <div :class="['desc', 'small', {active: value === transition}]" class="desc small">
                          <b>{{ $t(name) }}</b>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="setting-dropdown-container">
              <div :class="['settings-dropdown', {'active': settings2IsActive}]">
                <div class="settings-dropdown-wrapper">
                  <div class="desc small">
                    <b>{{ $t('Settings') }}:</b>
                  </div>
                  <label class="checkbox-label toggle-label">
                    <div class="desc small">
                      <b>{{ $t('Voice-over') }}</b>
                    </div>
                    <div class="toggle">
                      <input :checked="selectedScene?.voiceOver" :value="selectedScene?.voiceOver"
                             @change="toggleVoiceOver" type="checkbox"/>
                      <div class="checkbox"></div>
                    </div>
                  </label>
                  <label class="checkbox-label toggle-label">
                    <div class="desc small">
                      <b>{{ $t('Background music') }}</b>
                    </div>
                    <div class="toggle">
                      <input :checked="!!backGroundMusicVolume" :value="!!backGroundMusicVolume.value"
                             @change="toggleBackgroundMusic" type="checkbox"/>
                      <div class="checkbox"></div>
                    </div>
                  </label>
                </div>
              </div>
            </div>


            <a @click.prevent="toggleSubtitles" class="text-button">
              <img
                  class="img"
                  src="./../assets/img/icons/subtitles.svg"
              />
            </a>
            <a v-if="isBackgroundVideo" @click.prevent="barMinValue = 0; barMaxValue = actualSceneDuration; cutIsVisible = true; resetAll();" class="text-button">
              <img
                  class="img"
                  src="./../assets/img/icons/cut.svg"
              />
            </a>
<!--            <a class="text-button">-->
<!--              <img-->
<!--                  class="img"-->
<!--                  src="./../assets/img/icons/underline.svg"-->
<!--              />-->
<!--            </a>-->
            <a @click.prevent="settings2IsActive = !settings2IsActive" class="text-button">
              <img
                  class="img"
                  src="./../assets/img/icons/settings.svg"
              />
            </a>
            <a @click.prevent="deleteScene" class="text-button">
              <img
                  class="img"
                  src="./../assets/img/icons/bin2.svg"
              />
            </a>
          </div>
        </div>
        <div class="video-generating-left-bottom">
          <div v-if="scenes" class="list scene-list">
            <div v-for="(scene, index) in scenes" :key="index" class="item">
              <video
                  v-if="scene?.backgroundType === 'video'"
                  :id="`video-${index}`"
                  :src="scene?.backgroundUri"
                  class="img"
                  width="130"
                  height="72"
                  @click="selectedSceneNum = index; resetAudio()"
              ></video>
              <img v-else
                   :src="scene?.backgroundUri"
                   class="img"
                   @click="selectedSceneNum = index; resetAudio()"
              />
              <div class="desc small">
                {{ $t(`Scene`) }} {{ index + 1 }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="video-generating-right">
        <div class="video-generating-right-header">
          <div class="text">
            <div class="desc small">
              {{ $t('Video duration') }}:
            </div>
            <div class="desc small">
              <b>{{ formatTime(videoDuration) }}</b>
            </div>
          </div>
          <div class="buttons">
            <button @click="handlePreview" class="button button-play lined">
              <span>{{ $t('Preview') }}</span>
              <img
                  src="./../assets/img/icons/play.svg"
                  class="img"
              >
            </button>
            <button @click="downloadVideo" class="button">
              <span>{{ $t('DOWNLOAD') }}</span>
            </button>
          </div>
        </div>

        <div class="video-generating-right-bar video-generating-right-bar2">
          <div class="tabs">
            <a :class="['tabs__item', {'active': activeTab == 1}]" @click="activeTab = 1">
              <div class="desc">
                <b>{{ $t('Story') }}</b>
              </div>
            </a>
            <a :class="['tabs__item', {'active': activeTab == 2}]" @click="activeTab = 2">
              <div class="desc">
                <b>{{ $t('Visuals') }}</b>
              </div>
            </a>
            <a :class="['tabs__item', {'active': activeTab == 3}]" @click="activeTab = 3">
              <div class="desc">
                <b>{{ $t('Audio') }}</b>
              </div>
            </a>
<!--            <a :class="['tabs__item', {'active': activeTab == 4}]" @click="activeTab = 4">-->
<!--              <div class="desc">-->
<!--                <b>{{ $t('Text') }}</b>-->
<!--              </div>-->
<!--            </a>-->
<!--            <a :class="['tabs__item', {'active': activeTab == 5}]" @click="activeTab = 5">-->
<!--              <div class="desc">-->
<!--                <b>{{ $t('Layers') }}</b>-->
<!--              </div>-->
<!--            </a>-->
          </div>
        </div>
        <div class="video-generating-right-main">
          <StoryTab v-if="activeTab == 1"/>
          <div class="tab-preview2" v-if="activeTab == 3">
            <div class="tabs">
              <a
                  :class="['tabs__item', {'active': audioActiveTab == 2}]"
                  @click="audioActiveTab = 2"
              >
                <div class="desc small">
                  <b>{{ $t('My uploads') }}</b>
                </div>
              </a>
              <a
                  :class="['tabs__item', {'active': audioActiveTab == 3}]"
                  @click="audioActiveTab = 3"
              >
                <div class="desc small">
                  <b>{{ $t('Voiceover') }}</b>
                </div>
              </a>
            </div>
            <div class="library library2" v-if="audioActiveTab == 1">
              <div class="library-header">
                <label class="search-label">
                  <TextInput
                      name="title"
                      type="text"
                      placeholder="Search tracks"
                      required
                  />
                  <img
                      class="search-img"
                      src="./../assets/img/icons/search.svg"
                  />
                </label>
                <a
                    :class="['text-button filter-button', {'active': filterIsOpen}]"
                    @click="filterIsOpen = !filterIsOpen"
                >
                  <img
                      class="img"
                      src="./../assets/img/icons/filter.svg"
                  />
                </a>
              </div>
              <div :class="['library-filters', {'active': filterIsOpen}]">
                <div class="library-filters-wrapper">
                  <div class="select-container">
                    <div class="select" @click="selectDropdownIsActive = !selectDropdownIsActive">
                      <div class="desc small">{{ $t('Mood') }}</div>
                      <img
                          src="./../assets/img/arrow-down-dark.svg"
                          class="img"
                      >
                    </div>
                    <div :class="['settings-dropdown select-dropdown', {'active': selectDropdownIsActive}]">
                      <div class="select-dropdown-wrapper">
                        <div class="checkbox-list">
                          <label class="checkbox-label" v-for="item in 7" :key="item">
                            <input type="checkbox"/>
                            <div class="checkbox"></div>
                            <div class="desc small">{{ $t('Passionate') }}</div>
                          </label>
                        </div>
                        <div class="buttons">
                          <button class="button extrasmall lined">
                            <span>{{ $t('Clear') }}</span>
                          </button>
                          <button class="button extrasmall">
                            <span>{{ $t('Apply') }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="select-container">
                    <div class="select" @click="selectDropdownIsActive2 = !selectDropdownIsActive2">
                      <div class="desc small">{{ $t('Purpose') }}</div>
                      <img
                          src="./../assets/img/arrow-down-dark.svg"
                          class="img"
                      >
                    </div>
                    <div :class="['settings-dropdown select-dropdown', {'active': selectDropdownIsActive2}]">
                      <div class="select-dropdown-wrapper">
                        <div class="checkbox-list">
                          <label class="checkbox-label" v-for="item in 7" :key="item">
                            <input type="checkbox"/>
                            <div class="checkbox"></div>
                            <div class="desc small">{{ $t('Passionate') }}</div>
                          </label>
                        </div>
                        <div class="buttons">
                          <button class="button extrasmall lined">
                            <span>{{ $t('Clear') }}</span>
                          </button>
                          <button class="button extrasmall">
                            <span>{{ $t('Apply') }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="select-container">
                    <div class="select" @click="selectDropdownIsActive3 = !selectDropdownIsActive3">
                      <div class="desc small">{{ $t('Genre') }}</div>
                      <img
                          src="./../assets/img/arrow-down-dark.svg"
                          class="img"
                      >
                    </div>
                    <div :class="['settings-dropdown select-dropdown', {'active': selectDropdownIsActive3}]">
                      <div class="select-dropdown-wrapper">
                        <div class="checkbox-list">
                          <label class="checkbox-label" v-for="item in 7" :key="item">
                            <input type="checkbox"/>
                            <div class="checkbox"></div>
                            <div class="desc small">{{ $t('Passionate') }}</div>
                          </label>
                        </div>
                        <div class="buttons">
                          <button class="button extrasmall lined">
                            <span>{{ $t('Clear') }}</span>
                          </button>
                          <button class="button extrasmall">
                            <span>{{ $t('Apply') }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="select-container">
                    <div class="select" @click="selectDropdownIsActive4 = !selectDropdownIsActive4">
                      <div class="desc small">{{ $t('Duration') }}</div>
                      <img
                          src="./../assets/img/arrow-down-dark.svg"
                          class="img"
                      >
                    </div>
                    <div :class="['settings-dropdown select-dropdown', {'active': selectDropdownIsActive4}]">
                      <div class="select-dropdown-wrapper">
                        <div class="desc small">
                          <b>{{ $t('Duration (min)') }}:</b>
                        </div>
                        <label>
                          <TextInput
                              name="title"
                              type="text"
                              value="6"
                          />
                        </label>
                        <div class="buttons">
                          <button class="button extrasmall lined">
                            <span>{{ $t('Clear') }}</span>
                          </button>
                          <button class="button extrasmall">
                            <span>{{ $t('Apply') }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list audio-list">
                <div class="list-wrapper">
                  <div :class="['item', {'active': audioApplied}]" v-for="item in 9" :key="item">
                    <div class="left">
                      <img
                          src="./../assets/img/icons/play3.svg"
                          class="img"
                      >
                      <div class="text">
                        <div class="desc small">
                          <b>{{ $t('Track 1') }}</b>
                        </div>
                        <div class="desc small">
                          {{ $t('Abstract, Beautiful,Abstract, Beautiful ') }}
                        </div>
                      </div>
                    </div>
                    <div class="time">
                      <div class="applied">
                        <div class="desc small">
                          <b>{{ $t('Applied') }}</b>
                        </div>
                        <img
                            src="./../assets/img/icons/smallCross.svg"
                            class="img"
                            @click="audioApplied = false"
                        >
                      </div>
                      <div class="desc small">{{ $t('03:43') }}</div>
                    </div>
                    <a class="button extrasmall" @click="audioApplied = true">
                      <span>{{ $t('Apply') }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <UploadsAudioTab v-if="audioActiveTab == 2"/>

            <VoiceOverTab v-if="audioActiveTab == 3"/>

          </div>
          <div class="tab-preview2" v-if="activeTab == 2">
            <div class="tabs">
              <a
                  :class="['tabs__item', {'active': visualsActiveTab == 1}]"
                  @click="visualsActiveTab = 1"
              >
                <div class="desc small">
                  <b>{{ $t('Library') }}</b>
                </div>
              </a>
              <a
                  :class="['tabs__item', {'active': visualsActiveTab == 2}]"
                  @click="visualsActiveTab = 2"
              >
                <div class="desc small">
                  <b>{{ $t('My uploads') }}</b>
                </div>
              </a>
            </div>

            <UploadsVisualsTab v-if="visualsActiveTab == 2"/>

            <VisualsLibraryTab v-if="visualsActiveTab == 1"/>
          </div>
          <div class="tab-preview2" v-if="activeTab == 4">
            <div class="library library2">
              <div class="list audio-list text-list">
                <div class="list-wrapper">
                  <div class="desc small">
                    <b>{{ 'Decor text boxes' }}</b>
                  </div>
                  <div class="item">
                    <div class="text-button">
                      <img
                          class="img"
                          src="./../assets/img/icons/plus3.svg"
                      />
                    </div>
                    <div class="title">{{ $t('Heading') }}</div>
                  </div>
                  <div class="item">
                    <div class="text-button">
                      <img
                          class="img"
                          src="./../assets/img/icons/plus3.svg"
                      />
                    </div>
                    <div class="title subhading">{{ $t('Subhading') }}</div>
                  </div>
                  <div class="item">
                    <div class="text-button">
                      <img
                          class="img"
                          src="./../assets/img/icons/plus3.svg"
                      />
                    </div>
                    <div class="title body-text">{{ $t('Body text') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-preview tab-preview2" v-if="activeTab == 5">
            <div class="scene-list scene-list2">
              <div class="item">
                <div class="item-header">
                  <div class="desc small">{{ $t('Story') }}</div>
                  <img
                      class="img"
                      src="./../assets/img/icons/move.svg"
                  />
                </div>
                <div class="item-main">
                  <div class="desc">
                    {{ $t('Regular hospital visits can be expensive, particularly in rural areas, due to trave...') }}
                  </div>
                  <div class="buttons">
                    <a class="text-button" @click="eye = !eye">
                      <img
                          v-if="eye"
                          class="img"
                          src="./../assets/img/icons/eye.svg"
                      />
                      <img
                          v-if="!eye"
                          class="img"
                          src="./../assets/img/icons/eye2.svg"
                      />
                    </a>
                    <a class="text-button">
                      <img
                          class="img"
                          src="./../assets/img/icons/copy.svg"
                      />
                    </a>
                    <a class="text-button">
                      <img
                          class="img"
                          src="./../assets/img/icons/bin2.svg"
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="item-header">
                  <div class="desc small">{{ $t('Text') }}</div>
                  <img
                      class="img"
                      src="./../assets/img/icons/move.svg"
                  />
                </div>
                <div class="item-main">
                  <div class="desc">
                    {{ $t('Your text goes here') }}
                  </div>
                  <div class="buttons">
                    <a class="text-button" @click="eye = !eye">
                      <img
                          v-if="eye"
                          class="img"
                          src="./../assets/img/icons/eye.svg"
                      />
                      <img
                          v-if="!eye"
                          class="img"
                          src="./../assets/img/icons/eye2.svg"
                      />
                    </a>
                    <a class="text-button">
                      <img
                          class="img"
                          src="./../assets/img/icons/copy.svg"
                      />
                    </a>
                    <a class="text-button">
                      <img
                          class="img"
                          src="./../assets/img/icons/bin2.svg"
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="item-header">
                  <div class="desc small">{{ $t('Background') }}</div>
                  <img
                      class="img"
                      src="./../assets/img/icons/move.svg"
                  />
                </div>
                <div class="item-main">
                  <img
                      class="item-img"
                      src="./../assets/img/img.png"
                  />
                  <div class="buttons">
                    <a class="text-button" @click="eye = !eye">
                      <img
                          v-if="eye"
                          class="img"
                          src="./../assets/img/icons/eye.svg"
                      />
                      <img
                          v-if="!eye"
                          class="img"
                          src="./../assets/img/icons/eye2.svg"
                      />
                    </a>
                    <a class="text-button">
                      <img
                          class="img"
                          src="./../assets/img/icons/copy.svg"
                      />
                    </a>
                    <a class="text-button">
                      <img
                          class="img"
                          src="./../assets/img/icons/bin2.svg"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <VideoPreviewModal v-if="modalsStore.videoPreviewModalIsVisible"/>
</template>

<script setup>
import {ref, onMounted, onBeforeUnmount, computed, watch, defineExpose} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {getModalsStore} from '../stores/modals';
import TextInput from '@/components/TextInput.vue';
import {useVideoStore} from "@/stores/video";
import {storeToRefs} from "pinia";
// import axios from "@/axios";
import UploadsVisualsTab from "@/components/UploadsVisualsTab.vue";
import StoryTab from "@/components/StoryTab.vue";
import VisualsLibraryTab from "@/components/VisualsLibraryTab.vue";
import UploadsAudioTab from "@/components/UploadsAudioTab.vue";
import VoiceOverTab from "@/components/VoiceOverTab.vue";
import VideoPreviewModal from "@/components/VideoPreviewModal.vue";
import {debounce} from "@/utils/utils";
import axios from "@/axios";
import MultiRangeSlider from "multi-range-slider-vue";

const fontSizes = [
  8,   // Extra small
  10,  // Small
  12,  // Medium small
  14,  // Medium
  16,  // Normal
  18,  // Medium large
  20,  // Large
  23,  // Extra large
  30,  // Heading
  36,  // Subheading
  48,  // Major heading
  64,  // Large display
  72   // Extra large display
];
let sceneTimeout = null;
let backgroundMusicTimeout = null;
let voiceOverTimeout = null
let onBackgroundMusicEnded;

const transitions = {
  'none': 'None',
  'wipeup': 'Wipe Up',
  'wipedown': 'Wipe Down',
  'wipeleft': 'Wipe Left',
  'wiperight': 'Wipe Right',
  'smoothleft': 'Smooth Left',
  'smoothright': 'Smooth Right',
  'radial': 'Radial',
  'circlecrop': 'Circle Crop',
  'hblur': 'HBlur',
  'fade': 'Fade',
}

const activeTab = ref(1);
const visualsActiveTab = ref(1);
const audioActiveTab = ref(2);

// State
const modalsStore = ref('');
const videoStore = useVideoStore();
// const step = ref(1);
// const settingsIsActive = ref(false);
const settings2IsActive = ref(false);
const ratioDropdownIsActive = ref(false);
const orientation = ref('landscape');
// const replaceDropdownIsVisible = ref(false);
const voiceOverStartWith = ref(0);

const player = ref(null);
const isPlaying = ref(false);
const previewType = ref(null);
const previewIsPlaying = ref(false);
const backGroundMusicVolume = ref(null);

const transitionDropdownIsActive = ref(false)
const updateRangeValues = async ({minValue, maxValue}) => {
  barMaxValue.value = maxValue;
  barMinValue.value = minValue;
  await player.value.pause();
  isPlaying.value = false;
  player.value.currentTime = minValue;
}


const eye = ref(false);
const cutIsVisible = ref(false)
const barMinValue = ref(0);
const barMaxValue = ref(1000);
const videoCutting = ref(false);

const route = useRoute()
const router = useRouter();

const {
  fetchVisualUploads,
  fetchAudioUploads,
  deleteScene,
  updateScene,
  // updateAllScenes,
  generatePreviewScene,
  downloadVideo,
  fetchProjects,
  searchProjects,
  replaceSceneText,
  cutScene
} = videoStore;

const handleSceneCut = async () => {
  if (!videoCutting.value) {
    videoCutting.value = true;

    try {
      await cutScene(barMinValue.value, barMaxValue.value);
      cutIsVisible.value = false;
    } catch (e) {
      console.error(e);
    } finally {
      videoCutting.value = false;
    }
  }
}


const {
  // projects,
  projectsFound,
  projectsSearchQuery,
  videoId,
  video,
  fonts,
  scenes,
  scenesDuration,
  videoDuration,
  selectedScene,
  selectedSceneNum,
  sceneDuration,
  actualSceneDuration,
  backgroundType,
  backgroundMusic,
  voiceOverMusic,
  media,
  mediaSearch,
  mediaPage,
  videoGenerating,
  isManualPreviewSceneGeneration,
  initialGeneration
} = storeToRefs(videoStore);

watch(
    () => video.value?.metadata?.audio?.backGroundMusicVolume,
    (newVolume) => {
      backGroundMusicVolume.value = newVolume;
    },
    { immediate: true }
);


const sceneDurationLocal = ref(sceneDuration?.value || 0);

watch(() => sceneDuration?.value, (newDuration) => {
  sceneDurationLocal.value = newDuration;
})

// Create a debounced version of searchProjects once
const debouncedSearchProjects = debounce(searchProjects, 400);

// Watch the search query and trigger debounced search
watch(projectsSearchQuery, () => {
  debouncedSearchProjects();
});

const pureColor = ref(selectedScene?.value?.textBackgroundColor || null);

// const voiceOverStartWith = computed(() => {
//   return scenesDuration?.value?.slice(0, selectedSceneNum.value).reduce((acc, curr) => acc + curr, 0) || 0;
// }

watch(selectedScene, () => {
  resetAudio()
  resetVideo()
  resetVoiceOver()
  isPlaying.value = false;
})

watch([scenesDuration, selectedSceneNum], ([newScenesDuration, newSelectedSceneNum]) => {
  voiceOverStartWith.value = newScenesDuration?.slice(0, newSelectedSceneNum).reduce((acc, curr) => acc + Math.round(curr), 0) || 0;
})

// watch(() => sceneDuration?.value, (newDuration) => {\
// })

// const metadata = computed(() => {
//   return video?.value?.metadata
// })

const checkVideoTime = async () => {
  console.log(player.value.currentTime, sceneDuration.value, 'time');

  if (videoCutting.value && player.value.currentTime >= barMaxValue.value) {
    await resetAll();
    player.value.currentTime = barMinValue.value;
  } else if (player.value.currentTime >= sceneDuration.value) {
    console.log('checkVideoTime');
    previewIsPlaying.value = false;
    await resetAll();
  }
};

const videoEnded = () => {
  isPlaying.value = false;
  previewIsPlaying.value = false
}

const videoPause = () => {
  isPlaying.value = false;
}


const toggleSubtitles = () => {
  updateScene({
    subtitles: !selectedScene?.value?.subtitles,
  })
}

const toggleVoiceOver = () => {
  updateScene({
    voiceOver: !selectedScene?.value?.voiceOver,
  })
}

const toggleBackgroundMusic = () => {
  video.value.metadata.audio.backGroundMusicVolume = backGroundMusicVolume.value ? 0 : 0.1
}


const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${minutes} m ${remainingSeconds} s`;
}

const formatTimeCut = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
};

const updateStyles = (style, value) => {
  updateScene({
    [style]: value ? value : 'Arial',
  })
}

const toggleBold = () => {
  updateScene({
    fontWeight: selectedScene?.value?.fontWeight === 'bold' ? 'normal' : 'bold',
  });
}

const updateTransition = (transition) => {
  updateScene({
    transition,
  })
}

// const updateDuration = (all = false) => {
//   if (all) {
//     updateAllScenes({
//       // duration: sceneDuration.value,
//       minimumDuration: sceneDurationLocal.value,
//     })
//   } else {
//     updateScene({
//       // duration: sceneDuration.value,
//       minimumDuration: sceneDurationLocal.value,
//     })
//   }
// }

function checkIsItalic(str) {
  const regex = /^<i\b[^>]*>.*<\/i>$/is;
  return regex.test(str);
}

function checkIsUnderlined(str) {
  const regex = /^<u\b[^>]*>.*<\/u>$/is;
  return regex.test(str);
}

const toggleItalic = () => {
  const text = selectedScene?.value?.text;

  if (text) {
    if (checkIsItalic(text)) {
      replaceSceneText(text.replace(/<\/?i\b[^>]*>/gi, ''));
    } else {
      replaceSceneText(`<i>${text}</i>`);
    }
  }
}

const toggleUnderline = () => {
  const text = selectedScene?.value?.text;

  if (text) {
    if (checkIsUnderlined(text)) {
      replaceSceneText(text.replace(/<\/?u\b[^>]*>/gi, ''));
    } else {
      replaceSceneText(`<u>${text}</u>`);
    }
  }
}

const isBackgroundVideo = computed(() => backgroundType.value === 'video')

const sceneStyles = computed(() => {
  return {
    fontFamily: selectedScene?.value?.fontFamily ? selectedScene?.value?.fontFamily : 'Arial',
    fontSize: selectedScene?.value?.fontSize ? `${selectedScene?.value?.fontSize}px` : '23px',
    fontWeight: selectedScene?.value?.fontWeight ? selectedScene?.value?.fontWeight : 'normal',
    backgroundColor: 'transparent',
  }
})

const transition = computed(() => {
  return selectedScene?.value?.transition ? selectedScene?.value?.transition : 'none';
})


const togglePlay = async () => {
  // const playing = isPlaying.value;

  if (backgroundType.value === 'image') {
    isPlaying.value = !isPlaying.value;

    if (isPlaying.value) {
      // Установим таймаут для завершения сцены
      sceneTimeout = setTimeout(() => {
        isPlaying.value = false;
        previewIsPlaying.value = false;
      }, Math.round(selectedScene?.value?.duration) * 1000); // Длительность сцены в миллисекундах
    } else {
      previewIsPlaying.value = false;
      await resetAll();
      clearTimeout(sceneTimeout);  // Очищаем таймаут при остановке
    }
    return;
  }

  if (backgroundType.value === 'video') {
    if (player.value?.paused) {
      player.value.play();

      // Синхронизация видео с длительностью сцены
      sceneTimeout = setTimeout(() => {
        player.value.pause();
        player.value.currentTime = 0;
        isPlaying.value = false;
      }, Math.round(selectedScene?.value?.duration) * 1000);
    } else {
      await resetAll();
    }
  }
};


const resetAll = async () => {
  await resetVideo();
  await resetAudio();
  await resetVoiceOver();
  clearTimeout(sceneTimeout);  // Очищаем таймаут при сбросе
  clearTimeout(backgroundMusicTimeout);  // Очищаем таймаут при сбросе
  clearTimeout(voiceOverTimeout);  // Очищаем таймаут при сбросе
}

const resetVideo = async () => {
  if (backgroundType.value === 'video') {
    if (player.value) {
      player.value.currentTime = 0;
      await player.value?.pause();
    }
  } else {
    isPlaying.value = false;
  }
};

const resetAudio = async () => {
  if (backgroundMusic.value) {
    await backgroundMusic.value.pause();
    backgroundMusic.value.currentTime = 0;
    backgroundMusic.value.removeEventListener('ended', onBackgroundMusicEnded);
  }
}

const resetVoiceOver = async () => {
  if (voiceOverMusic.value) {
    await voiceOverMusic.value.pause();
    voiceOverMusic.value.currentTime = 0;
  }
};

const playVideo = async (value) => {
  if (value) {
    if (backgroundType.value === 'video') {
      await player.value.play();

      // Таймер для завершения видео по длительности сцены
      sceneTimeout = setTimeout(() => {
        player.value.pause();
        player.value.currentTime = 0;
        isPlaying.value = false;
        previewIsPlaying.value = false;
      }, Math.round(selectedScene?.value?.duration) * 1000);  // Преобразуем в миллисекунды
    } else if (backgroundType.value === 'image') {
      sceneTimeout = setTimeout(() => {
        isPlaying.value = false;
        previewIsPlaying.value = false;
      }, Math.round(sceneDuration.value) * 1000);  // Преобразуем в миллисекунды
    }

    if (backgroundMusic.value) {
      await backgroundMusic.value.play();

      // Определяем функцию обработчика для события 'ended'
      onBackgroundMusicEnded = () => {
        backgroundMusic.value.currentTime = 0;
        backgroundMusic.value.play();
      };

      // Установим обработчик и таймаут для фоновой музыки
      backgroundMusic.value.addEventListener('ended', onBackgroundMusicEnded);

      backgroundMusicTimeout = setTimeout(() => {
        backgroundMusic.value.pause();
        backgroundMusic.value.currentTime = 0;
        // Удаляем обработчик 'ended' при остановке
        backgroundMusic.value.removeEventListener('ended', onBackgroundMusicEnded);
      }, Math.round(sceneDuration.value) * 1000);
    }

    if (voiceOverMusic.value) {
      voiceOverMusic.value.currentTime = voiceOverStartWith.value;
      await voiceOverMusic.value.play();

      // Таймаут для завершения озвучки
      voiceOverTimeout = setTimeout(() => {
        voiceOverMusic.value.pause();
        voiceOverMusic.value.currentTime = 0;
      }, Math.round(sceneDuration.value) * 1000);
    }

    isPlaying.value = true;
  } else {
    // Сброс всех таймаутов и обработчиков
    await resetAll();
  }
};

const handleScenePreview = async () => {
  if (!videoGenerating.value) {
    await resetAll();
    previewType.value = 'scene';

    if (previewIsPlaying.value) {
      previewIsPlaying.value = false;
    } else {
      await generatePreviewScene();
    }
  }
}

const handlePreview = async () => {
  if (!videoGenerating.value) {
    await resetAll();
    previewType.value = 'video';
    await generatePreviewScene();
  }
}

const deleteProject = async (id) => {
  try {
    await axios.delete(process.env.VUE_APP_API + `video/${id}`);
    await searchProjects();
  } catch (e) {
    console.error(e);
  }
}

// const scenePreviews = ref([]);

// const capturePreview = (index) => {
//   const video = document.querySelector(`video[id="video-${index}"]`);
//
//   console.log(`canvas[ref="canvas-${index}"]`)
//
//   const canvas = document.querySelector(`canvas[id="canvas-${index}"]`);
//   const context = canvas.getContext('2d');
//
//   // Установите размеры канваса в соответствие с размерами видео
//   canvas.width = video.videoWidth;
//   canvas.height = video.videoHeight;
//
//   // Нарисуйте кадр видео на канвасе
//   context.drawImage(video, 0, 0, canvas.width, canvas.height);
//
//   // Преобразуйте канвас в изображение
//   scenePreviews.value[index] = canvas.toDataURL('image/png'); // Установите источник изображения превью
// };

// Наблюдение за изменениями в сценах, чтобы очищать превью

watch(scenes, () => {
  if (scenes.value && scenes.value.length >= 1) {
    if (!selectedSceneNum.value || selectedSceneNum.value > scenes.value.length) {
      selectedSceneNum.value = 0;
    }
  } else {
    selectedSceneNum.value = null;
  }
});

const idCorresponds = computed(() => {
  return video?.value?.id && route.params.id && video?.value?.id == route.params.id;
})

watch([activeTab, visualsActiveTab], async ([newActiveTab, newVisualsActiveTab]) => {
  if (newActiveTab === 2 && newVisualsActiveTab === 2) {
    fetchVisualUploads();
  }
})

watch([activeTab, audioActiveTab], async ([newActiveTab, newAudioActiveTab]) => {
  if (newActiveTab === 3 && newAudioActiveTab === 2) {
    fetchAudioUploads();
  }
})

onMounted(async () => {
  modalsStore.value = getModalsStore();

  await Promise.all([fetchProjects(), searchProjects()]);

  if (route.params.id) {
    videoId.value = route.params.id;
  }

  if (!videoStore.fonts.value || videoStore.fonts.value.length === 0) {
    videoStore.fetchFonts();
  }

  if (!videoStore.media.value || videoStore.media.value.length === 0) {
    videoStore.fetchMedia();
  }
});

onBeforeUnmount(() => {
  media.value = [];
  mediaSearch.value = '';
  mediaPage.value = 1;
})

watch(() => route.params.id, (newId) => {
  if (newId) {
    videoId.value = newId;
  }
});

watch(selectedScene?.value?.textBackgroundColor, (color) => {
  pureColor.value = color;
});

watch(pureColor, (color) => {
  updateStyles('textBackgroundColor', color);
})

watch(isManualPreviewSceneGeneration, (state) => {
  if (state === 'success') {
    if (previewType.value === 'scene') {
      previewIsPlaying.value = true
      playVideo(true);
    } else if (previewType.value === 'video') {
      modalsStore.value.openVideoPreviewModal();
    }
  }
})

const clickOutside = () => {
  if (transitionDropdownIsActive.value) {
    transitionDropdownIsActive.value = false;
  }
}

const clickTransition = () => {
  transitionDropdownIsActive.value = !transitionDropdownIsActive.value;
}

defineExpose({player})
</script>
